/**
 * Concatena o identificador de tenant ao path base com exatamente uma barra
 * separadora. Espelha `prepararMenusTenant`.
 */
export function composeTenantPath(basePath: string, identifier: string): string {
  if (basePath.charAt(basePath.length - 1) === '/') {
    return basePath + identifier;
  }

  return basePath + '/' + identifier;
}
